module.exports = __webpack_public_path__ + "img/mini-app-spring.186852f.png";